import moment from 'moment';

/** Default report window: day after data entry cap through today, or calendar YTD. */
export function getDefaultJournalHealthDateRange(companyprofile = {}) {
  const today = moment().format('DD/MM/YYYY');
  const cap = (companyprofile.dataentry_date_cap || '').trim();

  if (cap.length === 10) {
    return {
      dateone: moment(cap, 'DD/MM/YYYY').add(1, 'day').format('DD/MM/YYYY'),
      datetwo: today,
    };
  }

  return {
    dateone: moment().startOf('year').format('DD/MM/YYYY'),
    datetwo: today,
  };
}

export function periodLabel(dateone, datetwo) {
  if (!dateone || !datetwo) {
    return 'No period selected';
  }
  return `${dateone} → ${datetwo}`;
}
